<template>
  <div class="md:mt-8 lg:mt-8 mt-4">
    <div class="flex justify-center">
      <a @click="handleOpenLink(linkedin)" class="cursor-pointer">
        <i class="fab fa-linkedin-in mx-2"></i>
      </a>
      <a @click="handleOpenLink(twitter)" class="cursor-pointer">
        <i class="fab fa-twitter mx-2"></i>
      </a>
      <a @click="handleOpenLink(facebook)" class="cursor-pointer">
        <i class="fab fa-facebook-f mx-2"></i>
      </a>
      <a @click="handleOpenLink(youtube)" class="cursor-pointer">
        <i class="fab fa-youtube mx-2"></i>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      linkedin: "",
      twitter: "",
      youtube: "",
      facebook: ""
    };
  },
  props: {
    userDetails: Object
  },
  methods: {
    handleOpenLink(link) {
      window.open(link, "_blank");
    },
    verifyLink() {
      if (
        this.userDetails.linkedin.includes("https://") ||
        this.userDetails.twitter.includes("https://") ||
        this.userDetails.facebook.includes("https://") ||
        this.userDetails.youtube.includes("https://")
      ) {
        this.linkedin = this.userDetails.linkedin;
        this.youtube = this.userDetails.youtube;
        this.twitter = this.userDetails.twitter;
        this.facebook = this.userDetails.facebook;
      } else {
        this.linkedin = "https://" + this.userDetails.linkedin;
        this.youtube = "https://" + this.userDetails.youtube;
        this.twitter = "https://" + this.userDetails.twitter;
        this.facebook = "https://" + this.userDetails.facebook;
      }
    }
  },
  mounted() {
    this.verifyLink();
  }
};
</script>
